// import React, { useState, useEffect } from "react";
// import { onAuthStateChanged } from "firebase/auth";
// import { useLocation, useNavigate } from "react-router-dom";
// import { auth, firestore as db, database as realtimeDb } from "../FirebaseConfig";
// import { doc, getDoc } from "firebase/firestore";
// import { ref, get } from "firebase/database";
// import axios from "axios";
// import toast from "react-hot-toast";
// import useOffersProgress from "../components/useOffersProgress";
// const API_URL = "https://us-central1-tghc-web.cloudfunctions.net/";
// // const API_URL = "http://127.0.0.1:5001/tghc-web/us-central1/";



// const Checkout = () => {
//   const [user, setUser] = useState(null);
//   const [cartItems, setCartItems] = useState([]);
//   const [productDetails, setProductDetails] = useState([]);
//   const [addresses, setAddresses] = useState([]);
//   const [selectedAddress, setSelectedAddress] = useState(-1);
//   const [deliveryFee, setDeliveryFee] = useState(0);
//   const [loading, setLoading] = useState(true);
//   const [placingOrder, setPlacingOrder] = useState(false); // ✅ new state

//   const navigate = useNavigate();
//   const location = useLocation();
//   const queryParams = new URLSearchParams(location.search);
//   const productId = queryParams.get("productId");
//   const quantity = queryParams.get("quantity");
// const [stockIssues, setStockIssues] = useState([]); // [{productId, name, requested, available, reason}]

//   const fetchSingleProductDetails = async (productId, quantity) => {
//     try {
//       const productRef = doc(db, "products", productId);
//       const productSnap = await getDoc(productRef);
//       if (productSnap.exists()) {
//         const productData = productSnap.data();
//         const discountPrice = productData.prices.productPrice - productData.prices.productDiscount;
//         // setProductDetails([{ ...productData, quantity, discountPrice }]);
//         setProductDetails([{ ...productData, productId, quantity, discountPrice }]);

//       }
//     } catch (error) {
//       console.error("Error fetching product details:", error);
//     }
//   };
//   const computedSubtotal = productDetails.reduce(
//   (acc, it) => acc + it.discountPrice * it.quantity,
//   0
// );

// // Hook to calculate live offer progress (auto-fetches Realtime DB config)
// const offersProg = useOffersProgress({ subtotalOverride: computedSubtotal });


//   useEffect(() => {
//     const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
//       if (currentUser) {
//         setUser(currentUser);
//         await fetchAddresses(currentUser.uid);
//         await fetchDeliveryFee();
//         if (productId) {
//           await fetchSingleProductDetails(productId, parseInt(quantity));
//         } else {
//           await fetchCartItems(currentUser.uid);
//         }
//       } else {
//         navigate(`/login?redirect=/checkout${productId ? `&productId=${productId}&quantity=${quantity}` : ""}`);
//       }
//       setLoading(false);
//     });

//     return () => unsubscribe();
//   }, [navigate, productId, quantity]);

//   const fetchCartItems = async (userId) => {
//     const cartRef = doc(db, "customers", userId);
//     const cartSnap = await getDoc(cartRef);
//     if (cartSnap.exists()) {
//       const cartData = cartSnap.data().items || [];
//       setCartItems(cartData);
//       fetchProductDetails(cartData);
//     }
//   };
// ///////////////////////////
//   const validateBeforeCheckout = async ({ directProductId, directQty }) => {
//   try {
//     const itemsToCheck = [];

//     if (directProductId) {
//       // direct buy
//       const pRef = doc(db, "products", directProductId);
//       const pSnap = await getDoc(pRef);
//       if (!pSnap.exists()) {
//         return { ok: false, issues: [{ productId: directProductId, reason: "missing", name: "Product", requested: directQty, available: 0 }] };
//       }
//       const p = pSnap.data();
//       itemsToCheck.push({
//         productId: directProductId,
//         name: p.name,
//         requested: directQty,
//         available: p.stock ?? 0,
//       });
//     } else {
//       // cart checkout
//       // re-fetch each product fresh to avoid stale stock
//       const reads = await Promise.all(
//         (productDetails || []).map(async (pd) => {
//           const pRef = doc(db, "products", pd.productId);
//           const pSnap = await getDoc(pRef);
//           if (!pSnap.exists()) {
//             return { productId: pd.productId, name: pd.name || "Product", requested: pd.quantity, available: 0, missing: true };
//           }
//           const p = pSnap.data();
//           return {
//             productId: pd.productId,
//             name: p.name,
//             requested: pd.quantity,
//             available: p.stock ?? 0,
//           };
//         })
//       );
//       itemsToCheck.push(...reads);
//     }

//     // build issues list
//     const issues = itemsToCheck
//       .filter(it => (it.missing || it.available <= 0 || it.requested > it.available))
//       .map(it => ({
//         productId: it.productId,
//         name: it.name,
//         requested: it.requested,
//         available: it.available,
//         reason: it.missing ? "missing" : (it.available <= 0 ? "oos" : "insufficient")
//       }));

//     setStockIssues(issues);
//     return { ok: issues.length === 0, issues };
//   } catch (e) {
//     console.error("Validation error:", e);
//     toast.error("Could not validate stock. Please try again.");
//     return { ok: false, issues: [] };
//   }
// };

// ///////////////////////////


//   const fetchProductDetails = async (cartItems) => {
//     if (!cartItems.length) return;
//     try {
//       const productPromises = cartItems.map(async (cartItem) => {
//         const productRef = doc(db, "products", cartItem.productId);
//         const productSnap = await getDoc(productRef);
//         if (productSnap.exists()) {
//           const productData = productSnap.data();
//           const discountPrice = productData.prices.productPrice - productData.prices.productDiscount;
//           return {
//             ...productData,
//             productId: cartItem.productId,        // ⬅️ keep id
//             quantity: cartItem.quantity,
//             discountPrice,
//           };
//         }
//         return null;
//       });
//       const products = await Promise.all(productPromises);
//       setProductDetails(products.filter(Boolean));
//     } catch (error) {
//       console.error("Error fetching product details:", error);
//     }
//   };

//   const fetchAddresses = async (userId) => {
//     const userRef = doc(db, "customers", userId);
//     const userSnap = await getDoc(userRef);
//     if (userSnap.exists()) {
//       setAddresses(userSnap.data().address || []);
//       setSelectedAddress(userSnap.data().defaultAddress ?? -1);
//     }
//   };

//   const fetchDeliveryFee = async () => {
//     const feeRef = ref(realtimeDb, "config/deliveryFee");
//     const feeSnap = await get(feeRef);
//     if (feeSnap.exists()) {
//       setDeliveryFee(feeSnap.val() || 0);
//     }
//   };

//   // const handleCheckout = async (productId = null, quantity = null) => {
//   //   if (!user) return alert("Please log in first.");
//   //   if (selectedAddress === -1) return toast.error("Please select an address.");
//   //   if (placingOrder) return;

//   //   setPlacingOrder(true);

//   //   try {
//   //     const token = await user.getIdToken(true);
//   //     const checkoutType = productId ? "direct" : "cart";

//   //     const payload = {
//   //       checkoutType,
//   //       address: addresses[selectedAddress],
//   //     };

//   //     if (checkoutType === "direct") {
//   //       payload.productId = productId;
//   //       payload.quantity = quantity;
//   //     }

//   //     const response = await axios.post(`${API_URL}/createOrder`, payload, {
//   //       headers: {
//   //         Authorization: `Bearer ${token}`,
//   //         "Content-Type": "application/json",
//   //       },
//   //       withCredentials: true,
//   //     });

//   //     if (response.data.paymentUrl) {
//   //       window.location.href = response.data.paymentUrl;
//   //     } else {
//   //       alert("Order creation failed.");
//   //       setPlacingOrder(false);
//   //     }
//   //   } catch (error) {
//   //     console.error("Error during checkout:", error);
//   //     alert("Error processing checkout.");
//   //     setPlacingOrder(false);
//   //   }
//   // };

// //   const handleCheckout = async (productId = null, quantity = null) => {
// //   if (!user) return alert("Please log in first.");
// //   if (selectedAddress === -1) return toast.error("Please select an address.");
// //   if (placingOrder) return;

// //   setPlacingOrder(true);

// //   // ✅ fresh validation
// //   const { ok, issues } = await validateBeforeCheckout({
// //     directProductId: productId || undefined,
// //     directQty: productId ? parseInt(quantity) : undefined,
// //   });

// //   if (!ok) {
// //     // show a concise summary; per-item details are rendered in UI (step 5)
// //     if (issues?.length) {
// //       const first = issues[0];
// //       const msg =
// //         first.reason === "missing"
// //           ? `${first.name} is no longer available.`
// //           : first.reason === "oos"
// //           ? `${first.name} is out of stock.`
// //           : `${first.name}: only ${first.available} left (you requested ${first.requested}).`;
// //       toast.error(msg);
// //     } else {
// //       toast.error("Some items are not available in the requested quantity.");
// //     }
// //     setPlacingOrder(false);
// //     return; // ⬅️ hard stop; do not create order
// //   }

// //   try {
// //     const token = await user.getIdToken(true);
// //     const checkoutType = productId ? "direct" : "cart";

// //     const payload = {
// //       checkoutType,
// //       address: addresses[selectedAddress],
// //       ...(checkoutType === "direct" ? { productId, quantity: parseInt(quantity) } : {}),
// //     };

// //     const response = await axios.post(`${API_URL}/createOrder`, payload, {
// //       headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
// //       withCredentials: true,
// //     });

// //     if (response.data.paymentUrl) {
// //       window.location.href = response.data.paymentUrl;
// //     } else {
// //       alert("Order creation failed.");
// //       setPlacingOrder(false);
// //     }
// //   } catch (error) {
// //     console.error("Error during checkout:", error);
// //     alert("Error processing checkout.");
// //     setPlacingOrder(false);
// //   }
// // };



// const handleCheckout = async (productId = null, quantity = null) => {
//   if (!user) return alert("Please log in first.");
//   if (selectedAddress === -1) return toast.error("Please select an address.");
//   if (placingOrder) return;

//   setPlacingOrder(true);

//   // ✅ fresh validation (kept as-is)
//   const { ok, issues } = await validateBeforeCheckout({
//     directProductId: productId || undefined,
//     directQty: productId ? parseInt(quantity) : undefined,
//   });

//   if (!ok) {
//     if (issues?.length) {
//       const first = issues[0];
//       const msg =
//         first.reason === "missing"
//           ? `${first.name} is no longer available.`
//           : first.reason === "oos"
//           ? `${first.name} is out of stock.`
//           : `${first.name}: only ${first.available} left (you requested ${first.requested}).`;
//       toast.error(msg);
//     } else {
//       toast.error("Some items are not available in the requested quantity.");
//     }
//     setPlacingOrder(false);
//     return;
//   }

//   try {
//     const token = await user.getIdToken(true);
//     const checkoutType = productId ? "direct" : "cart";

//     const payload = {
//       checkoutType,
//       address: addresses[selectedAddress],
//       ...(checkoutType === "direct" ? { productId, quantity: parseInt(quantity) } : {}),
//     };

//     // 1) Create order on backend (returns: orderId, razorpayOrderId, razorpayKeyId, amountPaise)
//     const { data } = await axios.post(`${API_URL}createRazorOrder`, payload, {
//       headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
//       withCredentials: true,
//     });

//     if (!data?.razorpayOrderId || !data?.razorpayKeyId || !data?.amountPaise || !data?.orderId) {
//       toast.error("Order creation failed. Please try again.");
//       setPlacingOrder(false);
//       return;
//     }

//     // 2) Ensure Razorpay script is loaded (in case it's not added in index.html)
//     const ensureRazorpayScript = () =>
//       new Promise((resolve, reject) => {
//         if (window.Razorpay) return resolve();
//         const script = document.createElement("script");
//         script.src = "https://checkout.razorpay.com/v1/checkout.js";
//         script.onload = resolve;
//         script.onerror = () => reject(new Error("Failed to load Razorpay SDK"));
//         document.body.appendChild(script);
//       });

//     await ensureRazorpayScript();

//     // 3) Build Checkout options
//     const options = {
//       key: data.razorpayKeyId,
//       amount: data.amountPaise,                // in paise
//       currency: "INR",
//       name: "The Great Honey Co.",
//       description: "Order Payment",
//       order_id: data.razorpayOrderId,         // REQUIRED
//       // Server-to-server verification + redirect to your status page
//       callback_url: `${API_URL}razorpayCallback?orderId=${data.orderId}`,
//       redirect: true,                          // ensure full-page redirect (good for mobile)
//       notes: { orderId: data.orderId, checkoutType },

//       prefill: {
//         name: addresses[selectedAddress]?.customerName || "",
//         contact: addresses[selectedAddress]?.phone || "",
//         // email: user.email || "", // add if you want
//       },
//       theme: { color: "#f47d02" },
//       modal: {
//         ondismiss: () => {
//           // User closed the Checkout modal
//           // We don't mark failure here; your callback_url will still be called by Razorpay if paid.
//           setPlacingOrder(false);
//         },
//       },
//     };

//     // 4) Open Checkout
//     const rzp = new window.Razorpay(options);

//     // Optional: listen to client-side failure (signature still verified server-side)
//     rzp.on("payment.failed", () => {
//       // After failure, Razorpay may still redirect to callback_url (depends on flow).
//       // Your /payment-stat reads RTDB anyway, so we just release the button state here.
//       setPlacingOrder(false);
//     });

//     rzp.open();

//     // We release the button state; the rest is handled by server callback + redirect.
//     setPlacingOrder(false);
//   } catch (error) {
//     console.error("Error during checkout:", error);
//     toast.error("Error processing checkout.");
//     setPlacingOrder(false);
//   }
// };




//   return (
//     <div className="container mt-27 mb-20 mx-auto px-4 md:px-10 py-6 mt-20">
//       <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
//         {/* Address & Order Summary */}
//         <div className="md:col-span-2 space-y-6">
//           {/* Addresses */}
//           <div className="bg-white p-6 rounded-lg shadow-sm border">
//             <h2 className="text-xl font-bold mb-4">Delivery Address</h2>
//             {addresses.length > 0 ? (
//               addresses.map((address, index) => (
//                 <div
//                   key={index}
//                   className={`p-4 rounded-lg cursor-pointer transition ${
//                     selectedAddress === index
//                       ? "border-2 border-blue-500 bg-blue-50"
//                       : "border border-gray-200"
//                   }`}
//                   onClick={() => setSelectedAddress(index)}
//                 >
//                   <p className="font-semibold">{address.customerName}</p>
//                   <p className="text-sm text-gray-600">{`${address.addressLine1}, ${address.City}, ${address.State} - ${address.Pincode}`}</p>
//                   <p className="text-sm text-gray-600">{address.phone}</p>
//                 </div>
//               ))
//             ) : (
//               <p className="text-gray-500">No saved addresses</p>
//             )}
//           </div>


//           {addresses.length < 3 && (
//   <div className="mt-4">
//     <button
//       onClick={() =>
//         navigate(`/account?redirect=/checkout${productId ? `&productId=${productId}&quantity=${quantity}` : ""}`)
//       }
//       className="text-blue-600 underline text-sm font-medium"
//     >
//       + Add Address
//     </button>
//   </div>
// )}


//           {/* Order Summary */}
//           <div className="bg-white p-6 rounded-lg shadow-sm border">
//             <h2 className="text-xl font-bold mb-4">Order Summary</h2>
//             {productDetails.length > 0 ? (
//               <div className="space-y-4">
//                 {productDetails.map((item, i) => (
//                   <div key={i} className="flex items-center gap-4 border-b pb-4">
//                     <img src={item.thumbnail} alt={item.name} className="w-20 h-20 rounded-md object-cover" />
//                     <div className="flex-1">
//                       <p className="font-semibold">{item.name}</p>
//                       <p className="text-gray-600 text-sm">₹{item.discountPrice} × {item.quantity}</p>
//                     </div>
//                   </div>
//                 ))}
//               </div>
//             ) : (
//               <p className="text-gray-500">No items in cart</p>
//             )}
//           </div>
//         </div>

// {offersProg?.ready && (
//   <div className="bg-white p-4 rounded-lg border mt-4">
//     <div className="flex items-center gap-2 mb-2">
//       <span className="text-amber-600">🍯</span>
//       <h3 className="font-semibold">Offers for you</h3>
//       <span className="ml-auto text-xs text-gray-500">
//         {offersProg.unlockedCount}/{offersProg.totalTiers} unlocked
//       </span>
//     </div>

//     <div className="space-y-2">
//       {offersProg.tiersResolved.map((x, idx) => {
//         const unlocked = offersProg.subtotal >= (x.tier.thresholdAmount || 0);
//         const title =
//           x.variant?.title ||
//           (x.variant?.kind === "delivery_free"
//             ? "Free delivery"
//             : x.variant?.kind === "percent"
//             ? `Extra ${x.variant.value}% OFF`
//             : x.variant?.kind === "flat"
//             ? `₹${x.variant.value} OFF`
//             : "Offer");
//         const remaining = Math.max(0, (x.tier.thresholdAmount || 0) - offersProg.subtotal);

//         return (
//           <div
//             key={x.tier.id || idx}
//             className={`flex items-center justify-between rounded-lg border px-3 py-2 ${
//               unlocked ? "border-emerald-300 bg-emerald-50" : "border-gray-200 bg-white"
//             }`}
//           >
//             <div className="flex items-center gap-2">
//               <div
//                 className={`h-5 w-5 rounded-full flex items-center justify-center text-xs ${
//                   unlocked ? "bg-emerald-500 text-white" : "bg-gray-200 text-gray-600"
//                 }`}
//               >
//                 {unlocked ? "✓" : idx + 1}
//               </div>
//               <div>
//                 <div className="text-sm font-semibold">{title}</div>
//                 {!!x.variant?.code && (
//                   <div className="text-[11px] text-amber-700">Code: {x.variant.code}</div>
//                 )}
//                 {unlocked && x.variant?.applyAt === "payment" && x.variant?.razorpayOfferId && (
//                   <div className="text-[11px] text-emerald-700">Applied at payment</div>
//                 )}
//               </div>
//             </div>
//             <div className="text-right text-xs">
//               <div className="text-gray-500">Unlock at ₹{x.tier.thresholdAmount || 0}</div>
//               {!unlocked && <div className="text-amber-700 font-medium">₹{remaining} more</div>}
//             </div>
//           </div>
//         );
//       })}
//     </div>
//   </div>
// )}


// {stockIssues.length > 0 && (
//   <div className="mb-4 rounded-md border border-red-300 bg-red-50 p-3 text-sm text-red-800">
//     <p className="font-semibold mb-1">Can’t place order yet:</p>
//     <ul className="list-disc ml-5">
//       {stockIssues.map((it) => (
//         <li key={it.productId}>
//           {it.name}: {
//             it.reason === "missing" ? "no longer available"
//             : it.reason === "oos" ? "out of stock"
//             : `only ${it.available} left (you requested ${it.requested})`
//           }
//         </li>
//       ))}
//     </ul>
//   </div>
// )}


//         {/* Price & Checkout */}

//         <div className="bg-white p-6 rounded-lg shadow-md h-fit border">
//           <h2 className="text-xl font-bold mb-4">Price Details</h2>
//           <div className="space-y-2 text-gray-700 mb-6">
//           <div className="flex justify-between">

//           <p className="text-sm text-gray-700">Total {productDetails.length} item(s)</p>
//       <div className="flex items-center gap-2">
//         <p className="text-lg font-bold text-gray-900">₹{productDetails.reduce((acc, item) => acc + item.discountPrice * item.quantity, 0)}</p>
//         {/* <p className="text-sm text-red-500 line-through">+ ₹50</p>
//         <p className="text-sm text-green-600 font-semibold">Free Delivery</p> */}
//       </div>
//       </div>

//           {/* <div className="flex justify-between">
//   <span>Delivery Fee</span>
//   <div className="text-right">

//     <span className="line-through text-gray-400 mr-1">₹50</span>
//     <span className="text-green-600 font-semibold">Free</span>
//   </div>
// </div> */}
// <div className="flex justify-between">
//   <span>Delivery Fee</span>
//   <div className="text-right">
//     {deliveryFee === 0 ? (
//       <>
//         {/* If you know the base fee, show it struck-through. Otherwise delete the next line */}
//         <span className="line-through text-gray-400 mr-1">₹65</span>
//         <span className="text-green-600 font-semibold">Free</span>
//       </>
//     ) : (
//       <span className="text-gray-800">₹{deliveryFee}</span>
//     )}
//   </div>
// </div>



//             {/* You can add more price breakdowns here */}
//           </div>

//           <button
//             onClick={() => handleCheckout(productId, parseInt(quantity))}
//             // disabled={placingOrder}
//             disabled={placingOrder || stockIssues.length > 0}

//             className={`w-full py-3 hidden md:block text-lg font-bold rounded-md transition ${
//               placingOrder
//                 ? "bg-yellow-300 cursor-not-allowed"
//                 : "bg-yellow-500 hover:bg-yellow-600 text-white"
//             }`}
//           >
//             {placingOrder ? "Initiating Payment..." : "Place Order"}
//           </button>
//         </div>
//       </div>


//       {/* ✅ Floating Bottom Bar for Mobile Devices */}
// {productDetails.length > 0 && (
//   <div className="fixed bottom-0 left-0 w-full bg-white border-t border-gray-300 p-4 flex justify-between items-center md:hidden z-50">
//     <div>
//       <p className="text-sm text-gray-700">{productDetails.length} item(s)</p>
//       <div className="flex items-center gap-2">
//         <p className="text-lg font-bold text-gray-900">₹{productDetails.reduce((acc, item) => acc + item.discountPrice * item.quantity, 0)}</p>
//         {/* <p className="text-sm text-red-500 line-through">+ ₹50</p>
//         <p className="text-sm text-green-600 font-semibold">Free Delivery</p> */}
//       </div>
//     </div>

//     <button
//       // disabled={placingOrder}
//       disabled={placingOrder || stockIssues.length > 0}

//       onClick={() => handleCheckout(productId, parseInt(quantity))}
//       className={`px-5 py-2 rounded-md font-bold text-white transition ${
//         placingOrder ? "bg-yellow-300 cursor-not-allowed" : "bg-yellow-500 hover:bg-yellow-600"
//       }`}
//     >
//       {placingOrder ? "Initiating..." : "Place Order →"}
//     </button>
//   </div>
// )}



//     </div>
//   );
// };

// export default Checkout;

import React, { useState, useEffect, useMemo } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { useLocation, useNavigate } from "react-router-dom";
import { auth, firestore as db, database as realtimeDb } from "../FirebaseConfig";
import { doc, getDoc } from "firebase/firestore";
import { ref, get } from "firebase/database";
import axios from "axios";
import toast from "react-hot-toast";
import { motion, AnimatePresence } from "framer-motion";
import { 
  IoChevronBackOutline, 
  IoLocationOutline, 
  IoBagCheckOutline, 
  IoLockClosedOutline,
  IoAddOutline,
  IoCheckmarkCircle
} from "react-icons/io5";
import { Truck, ShieldCheck, CreditCard, Sparkles, TrendingDown, Tag } from "lucide-react";

const API_URL = "https://us-central1-tghc-web.cloudfunctions.net/";

const Checkout = () => {
  const [user, setUser] = useState(null);
  const [productDetails, setProductDetails] = useState([]);
  const [addresses, setAddresses] = useState([]);
  const [selectedAddress, setSelectedAddress] = useState(-1);
  const [deliveryFee, setDeliveryFee] = useState(65);
  const [loading, setLoading] = useState(true);
  const [placingOrder, setPlacingOrder] = useState(false);
  
const [loadingMessage, setLoadingMessage] = useState("Securing your jar...");
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const productId = queryParams.get("productId");
  const quantity = queryParams.get("quantity") || 1;

  const FREE_DELIVERY_LIMIT = 299;

  // --- Calculations ---
  const billTotals = useMemo(() => {
    let subtotal = 0;
    let originalPriceTotal = 0;

    productDetails.forEach(it => {
      subtotal += (it.discountPrice * it.quantity);
      originalPriceTotal += (it.prices.productPrice * it.quantity);
    });

    const productSavings = originalPriceTotal - subtotal;
    const isFree = subtotal >= FREE_DELIVERY_LIMIT;
    const finalFee = isFree ? 0 : deliveryFee;
    const deliverySavings = isFree ? deliveryFee : 0;

    return { 
      subtotal, 
      productSavings,
      deliverySavings,
      finalFee, 
      total: subtotal + finalFee,
      totalCombinedSavings: productSavings + deliverySavings
    };
  }, [productDetails, deliveryFee]);

  // --- Logic ---
  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (currentUser) => {
      if (currentUser) {
        setUser(currentUser);
        setLoading(true); // 1. Keep loading active while fetching
        await fetchAddresses(currentUser.uid);
        await fetchDeliveryFeeConfig();
        productId ? await fetchSingleProduct(productId, parseInt(quantity)) : await fetchCartData(currentUser.uid);
      } else {
        const params = new URLSearchParams();
      params.set("redirect", "/checkout");
      if (productId) params.set("productId", productId);
      if (quantity) params.set("quantity", quantity);
        navigate(`/login?${params.toString()}`);
        // navigate(`/login?redirect=/checkout`);
      }
      setLoading(false);
    });
    return () => unsubscribe();
  }, [navigate, productId, quantity]);

  const fetchAddresses = async (uid) => {
    const snap = await getDoc(doc(db, "customers", uid));
    if (snap.exists()) {
      setAddresses(snap.data().address || []);
      setSelectedAddress(snap.data().defaultAddress ?? -1);
    }
  };

  const fetchDeliveryFeeConfig = async () => {
    const snap = await get(ref(realtimeDb, "config/deliveryFee"));
    if (snap.exists()) setDeliveryFee(snap.val());
  };

  const fetchSingleProduct = async (pId, qty) => {
    const snap = await getDoc(doc(db, "products", pId));
    if (snap.exists()) {
      const data = snap.data();
      const discPrice = data.prices.productPrice - data.prices.productDiscount;
      setProductDetails([{ ...data, productId: pId, quantity: qty, discountPrice: discPrice }]);
    }
  };

  const fetchCartData = async (uid) => {
    const snap = await getDoc(doc(db, "customers", uid));
    if (snap.exists()) {
      const items = snap.data().items || [];
      const detailedItems = await Promise.all(items.map(async (item) => {
        const pSnap = await getDoc(doc(db, "products", item.productId));
        if (pSnap.exists()) {
          const pData = pSnap.data();
          return { ...pData, productId: item.productId, quantity: item.quantity, discountPrice: pData.prices.productPrice - pData.prices.productDiscount };
        }
        return null;
      }));
      setProductDetails(detailedItems.filter(Boolean));
    }
  };

  const handlePayment = async () => {
    if (selectedAddress === -1) return toast.error("Please select an address");
    
    setPlacingOrder(true);
    setLoadingMessage("Initiating Secure Payment..."); // Phase 1
    try {
      const token = await user.getIdToken(true);
      // setTimeout(() => setLoadingMessage("Connecting to Razorpay..."), 800); // Phase 2
      const { data } = await axios.post(`${API_URL}createRazorOrder`, {
        checkoutType: productId ? "direct" : "cart",
        address: addresses[selectedAddress],
        ...(productId ? { productId, quantity: parseInt(quantity) } : {})
      }, { headers: { Authorization: `Bearer ${token}` } });

      const options = {
        key: data.razorpayKeyId,
        amount: data.amountPaise,
        currency: "INR",
        name: "The Great Honey Co.",
        order_id: data.razorpayOrderId,
        callback_url: `${API_URL}razorpayCallback?orderId=${data.orderId}`,
        prefill: { name: addresses[selectedAddress].customerName, contact: addresses[selectedAddress].phone },
        theme: { color: "#ff6b00" },
        modal: { ondismiss: () => setPlacingOrder(false) }
      };

      
      new window.Razorpay(options).open();
    } catch (e) {
      toast.error("Payment failed to initialize.");
      setPlacingOrder(false);
    }
  };

  // if (loading) return (
  //   <div className="min-h-screen bg-[#fdf5e6] flex flex-col items-center justify-center">
  //      <motion.div animate={{ scale: [1, 1.1, 1] }} transition={{ repeat: Infinity }} className="text-3xl italic font-black text-[#ff6b00]">Gleaning...</motion.div>
  //   </div>
  // );

  // --- Replace `if (loading) return (...)` with this Skeleton UI ---
if (loading) {
  return (
    <div className="min-h-screen bg-[#fdf5e6] pb-32 pt-8 md:mt-20 mt-20 font-sans">
      <div className="max-w-5xl mx-auto px-4 animate-pulse">
        
        {/* Header Skeleton */}
        <div className="flex items-center justify-between mb-6 md:mb-8">
          <div className="w-8 h-8 bg-amber-200/50 rounded-full" />
          <div className="flex flex-col items-center gap-2">
            <div className="w-28 h-5 bg-amber-200/50 rounded" />
            <div className="w-20 h-3 bg-amber-200/30 rounded" />
          </div>
          <div className="w-8 h-8" />
        </div>

        <div className="grid lg:grid-cols-12 gap-5 md:gap-8">
          {/* Left Column Skeleton */}
          <div className="lg:col-span-7 space-y-4 md:space-y-6">
            <div className="bg-white/70 rounded-[1.2rem] md:rounded-[2rem] p-4 md:p-6 shadow-sm border border-orange-100/50">
              <div className="w-32 h-4 bg-gray-200 rounded mb-4" />
              <div className="space-y-3">
                <div className="h-16 bg-gray-100 rounded-xl" />
                <div className="h-16 bg-gray-100 rounded-xl" />
              </div>
            </div>

            <div className="bg-white/70 rounded-[1.2rem] md:rounded-[2rem] p-4 md:p-6 shadow-sm border border-orange-100/50">
              <div className="w-28 h-4 bg-gray-200 rounded mb-6" />
              <div className="space-y-4">
                {[1, 2].map((i) => (
                  <div key={i} className="flex gap-4 items-center">
                    <div className="w-14 h-14 bg-gray-200 rounded-lg shrink-0" />
                    <div className="flex-1 space-y-2">
                      <div className="w-3/4 h-4 bg-gray-200 rounded" />
                      <div className="w-1/4 h-3 bg-gray-200 rounded" />
                    </div>
                    <div className="w-12 h-4 bg-gray-200 rounded" />
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Right Column Skeleton */}
          <div className="lg:col-span-5">
            <div className="bg-white/70 rounded-[1.5rem] md:rounded-[2.5rem] p-6 shadow-sm border border-orange-100/50 space-y-4">
              <div className="w-24 h-4 bg-gray-200 rounded mb-6" />
              <div className="flex justify-between"><div className="w-16 h-3 bg-gray-200 rounded" /><div className="w-12 h-3 bg-gray-200 rounded" /></div>
              <div className="flex justify-between"><div className="w-20 h-3 bg-gray-200 rounded" /><div className="w-10 h-3 bg-gray-200 rounded" /></div>
              <div className="flex justify-between"><div className="w-24 h-3 bg-gray-200 rounded" /><div className="w-12 h-3 bg-gray-200 rounded" /></div>
              <div className="h-px bg-gray-100 my-4" />
              <div className="flex justify-between"><div className="w-24 h-5 bg-gray-200 rounded" /><div className="w-20 h-6 bg-gray-200 rounded" /></div>
              <div className="w-full h-12 bg-amber-200/60 rounded-xl mt-4" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

  return (
    <div className="min-h-screen bg-[#fdf5e6] pb-32 pt-8 md:mt-20 mt-20 font-sans">

      <AnimatePresence>
        {placingOrder && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 z-[100] flex flex-col items-center justify-center bg-white/60 backdrop-blur-md"
          >
            <div className="relative flex flex-col items-center">
              {/* Pulsing Honey Jar or Shield */}
              <motion.div
                animate={{ 
                  scale: [1, 1.2, 1],
                  rotate: [0, 5, -5, 0]
                }}
                transition={{ 
                  duration: 2, 
                  repeat: Infinity,
                  ease: "easeInOut"
                }}
                className="text-6xl md:text-7xl mb-6"
              >
                🍯
              </motion.div>
              
              {/* Spinning Ring */}
              <div className="absolute top-0 w-20 h-20 md:w-24 md:h-24 border-4 border-orange-100 border-t-[#ff6b00] rounded-full animate-spin" />
              
              <motion.p 
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                className="text-sm md:text-base font-black text-gray-800 tracking-tight"
              >
                {loadingMessage}
              </motion.p>
              
              <p className="text-[10px] md:text-xs text-gray-400 mt-2 uppercase tracking-widest font-bold">
                Please do not refresh or go back
              </p>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
      
      <div className="max-w-5xl mx-auto px-4">
        
        {/* Header - scaled down for mobile */}
        <div className="flex items-center justify-between mb-6 md:mb-8">
          <button onClick={() => navigate(-1)} className="p-1.5 md:p-2 bg-white rounded-full shadow-sm text-gray-600">
            <IoChevronBackOutline size={18} />
          </button>
          <div className="text-center">
            <h1 className="text-lg md:text-xl font-black text-gray-900 tracking-tight">Checkout</h1>
            <p className="flex items-center justify-center gap-1 text-[8px] md:text-[9px] font-bold text-emerald-600 uppercase tracking-widest mt-0.5">
              <IoLockClosedOutline /> Secure SSL Checkout
            </p>
          </div>
          <div className="w-8 md:w-10" />
        </div>

        <div className="grid lg:grid-cols-12 gap-5 md:gap-8">
          
          <div className="lg:col-span-7 space-y-4 md:space-y-6">
            {/* Address - Reduced padding and border radius on mobile */}
            <motion.div initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} className="bg-white rounded-[1.2rem] md:rounded-[2rem] p-4 md:p-6 shadow-sm border border-orange-100">
              <div className="flex justify-between items-center mb-4 md:mb-6">
                <h2 className="text-[11px] md:text-sm font-black text-gray-900 uppercase tracking-widest flex items-center gap-2">
                  <IoLocationOutline className="text-[#ff6b00]" size={16} /> Shipping to
                </h2>
                <button onClick={() => navigate('/account')} className="text-[9px] md:text-[10px] font-bold text-[#ff6b00] uppercase">
                   Edit
                </button>
              </div>
              <div className="space-y-2 md:space-y-3">
                {addresses.map((addr, idx) => (
                  <div key={idx} onClick={() => setSelectedAddress(idx)} className={`p-3 md:p-4 rounded-xl md:rounded-2xl border-2 transition-all cursor-pointer ${selectedAddress === idx ? "border-[#ff6b00] bg-orange-50/50" : "border-gray-50 bg-gray-50/30"}`}>
                    <div className="flex justify-between items-start">
                      <div>
                        <p className="font-bold text-gray-800 text-[12px] md:text-sm">{addr.customerName}</p>
                        <p className="text-[10px] md:text-[11px] text-gray-500 mt-0.5 md:mt-1">{addr.addressLine1}, {addr.City}</p>
                      </div>
                      {selectedAddress === idx && <IoCheckmarkCircle className="text-[#ff6b00]" size={18} />}
                    </div>
                  </div>
                ))}
              </div>
            </motion.div>

            {/* Review Jar - Scaled images and text */}
            <motion.div initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.1 }} className="bg-white rounded-[1.2rem] md:rounded-[2rem] p-4 md:p-6 shadow-sm border border-orange-100">
              <h2 className="text-[11px] md:text-sm font-black text-gray-900 uppercase tracking-widest mb-4 md:mb-6 flex items-center gap-2">
                <IoBagCheckOutline className="text-[#ff6b00]" size={16}/> Review Jar
              </h2>
              <div className="divide-y divide-orange-50">
                {productDetails.map((item, i) => (
                  <div key={i} className="flex items-center gap-3 md:gap-4 py-3 md:py-4 first:pt-0 last:pb-0">
                    <img src={item.thumbnail} className="w-12 h-12 md:w-16 md:h-16 rounded-lg md:rounded-xl object-cover bg-gray-50 border border-orange-50" alt="" />
                    <div className="flex-1">
                      <p className="text-[11px] md:text-xs font-bold text-gray-800 line-clamp-1">{item.name}</p>
                      <p className="text-[9px] md:text-[10px] text-gray-400 font-medium">Qty: {item.quantity}</p>
                      {item.prices.productDiscount > 0 && (
                        <div className="mt-0.5 md:mt-1">
                           <span className="text-[8px] md:text-[9px] font-black text-emerald-600 bg-emerald-50 px-1.5 md:px-2 py-0.5 rounded-full flex items-center gap-1 uppercase tracking-tight w-fit">
                              <Tag size={7} /> Saved ₹{item.prices.productDiscount * item.quantity}
                           </span>
                        </div>
                      )}
                    </div>
                    <div className="text-right">
                      {item.prices.productDiscount > 0 && (
                        <p className="text-[8px] md:text-[10px] text-gray-300 line-through">₹{item.prices.productPrice * item.quantity}</p>
                      )}
                      <p className="text-[12px] md:text-sm font-black text-gray-900">₹{item.discountPrice * item.quantity}</p>
                    </div>
                  </div>
                ))}
              </div>

              <div className="mt-4 md:mt-6 pt-3 md:pt-4 border-t border-dashed border-orange-100 flex justify-between items-center bg-orange-50/30 p-3 md:p-4 rounded-xl md:rounded-2xl">
                 <p className="text-[9px] md:text-[10px] font-black text-gray-500 uppercase">Jar Savings</p>
                 <p className="text-[11px] md:text-xs font-black text-emerald-600">Total Saved: ₹{billTotals.productSavings}</p>
              </div>
            </motion.div>
          </div>

          {/* Bill details sidebar */}
          <div className="lg:col-span-5 sticky top-28">
            <motion.div initial={{ opacity: 0, scale: 0.95 }} animate={{ opacity: 1, scale: 1 }} className="bg-white rounded-[1.5rem] md:rounded-[2.5rem] p-5 md:p-8 shadow-xl shadow-orange-200/20 border border-orange-50 overflow-hidden relative">
              
              {billTotals.totalCombinedSavings > 0 && (
                <div className="absolute top-0 right-0 bg-emerald-500 text-white px-3 md:px-4 py-1 md:py-1.5 rounded-bl-xl md:rounded-bl-2xl text-[8px] md:text-[9px] font-black uppercase tracking-widest flex items-center gap-1">
                  <Sparkles size={10} /> Saved ₹{billTotals.totalCombinedSavings}
                </div>
              )}

              <h2 className="text-[11px] md:text-sm font-black text-gray-900 uppercase tracking-widest mb-4 md:mb-6">Order Total</h2>
              
              <div className="space-y-3 md:space-y-4 mb-6 md:mb-8">
                <div className="flex justify-between text-[10px] md:text-xs font-bold text-gray-500 uppercase">
                  <span>Subtotal</span>
                  <span className="text-gray-900">₹{billTotals.subtotal.toFixed(2)}</span>
                </div>

                <div className="flex justify-between text-[10px] md:text-xs font-bold text-emerald-600 uppercase">
                   <span className="flex items-center gap-1"><TrendingDown size={12}/> Savings</span>
                   <span>- ₹{billTotals.productSavings.toFixed(2)}</span>
                </div>

                <div className="flex justify-between text-[10px] md:text-xs font-bold text-gray-500 uppercase">
                  <span className="flex items-center gap-1"><Truck size={12}/> Delivery Fee</span>
                  {billTotals.finalFee === 0 ? (
                    <div className="text-right">
                       <span className="line-through text-gray-300 mr-2 font-normal">₹{deliveryFee}</span>
                       <span className="text-emerald-600 font-black">FREE</span>
                    </div>
                  ) : (
                    <span className="text-gray-900">₹{billTotals.finalFee}</span>
                  )}
                </div>
              </div>

              <div className="border-t border-dashed border-orange-100 pt-4 md:pt-6 mb-6 md:mb-8">
                <div className="flex justify-between items-center">
                  <span className="text-[10px] md:text-xs font-black text-gray-900 uppercase">Grand Total</span>
                  <span className="text-2xl md:text-3xl font-black text-[#ff6b00]">₹{billTotals.total.toFixed(2)}</span>
                </div>
              </div>

              <button
                disabled={placingOrder}
                onClick={handlePayment}
                className="w-full bg-gradient-to-r from-[#ff6b00] to-[#cc7700] text-white py-3 md:py-4 rounded-xl md:rounded-2xl font-black uppercase tracking-widest text-[10px] md:text-[11px] shadow-lg shadow-orange-200"
              >
                {placingOrder ? "Connecting..." : "Confirm & Pay Now"}
              </button>

              <div className="mt-5 md:mt-6 flex items-center justify-center gap-3 md:gap-4 opacity-30 grayscale">
                <img src="https://upload.wikimedia.org/wikipedia/commons/8/89/Razorpay_logo.svg" className="h-3 md:h-3.5" alt="" />
                <div className="h-3 md:h-4 w-[1px] bg-gray-300" />
                <ShieldCheck size={14} />
              </div>
            </motion.div>
          </div>

        </div>
      </div>

      {/* MOBILE BOTTOM BAR - Optimized for smaller mobile tap areas */}
      <AnimatePresence>
        {!loading && (
          <motion.div 
            initial={{ y: 100 }} 
            animate={{ y: 0 }} 
            className="lg:hidden fixed bottom-0 left-0 right-0 bg-white p-4 pb-6 flex items-center justify-between shadow-[0_-10px_40px_rgba(0,0,0,0.08)] border-t border-orange-50 z-50 rounded-t-[2rem]"
          >
            <div>
               <motion.div 
                 initial={{ scale: 0.8, opacity: 0 }} 
                 animate={{ scale: 1, opacity: 1 }}
                 className="bg-emerald-100 text-emerald-700 text-[8px] px-2 py-0.5 rounded-full font-black uppercase tracking-tighter inline-flex items-center gap-1 mb-1"
               >
                 <Sparkles size={8} /> Savings: ₹{billTotals.totalCombinedSavings.toFixed(0)}
               </motion.div>
               <p className="text-xl font-black text-gray-900 tracking-tighter">₹{billTotals.total.toFixed(2)}</p>
            </div>
            
            <motion.button
              whileTap={{ scale: 0.95 }}
              disabled={placingOrder}
              onClick={handlePayment}
              className="bg-[#ff6b00] text-white px-6 py-3.5 rounded-xl font-black uppercase tracking-widest text-[9px] shadow-lg shadow-orange-100 flex items-center gap-2"
            >
              {placingOrder ? "..." : "Pay Now"}
            </motion.button>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default Checkout;